


















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IAddress, IBalanceX } from '@/services/addresses/models'
import Metadata from '@/components/Address/Metadata.vue'

@Component({
    components: {
        Metadata,
    },
})
export default class AddressSummary extends Vue {
    @Prop() metaData!: IAddress
    @Prop() addressID!: string
    @Prop() alias!: string
    @Prop() totalTransactionCount!: number
    @Prop() totalUtxoCount!: number
    @Prop() assets!: IBalanceX[]
    @Prop() prefix!: string
}
